// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5b9da31","637":"1d075cf2","882":"05490482","935":"b3d9eb62"}[chunkId] + ".chunk.js";
};